import { faHeart, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons"
import { useBookmarksContext } from "../../bookmarks/BookmarksContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const VenueBookmarkIcon = ({ venue }) => {
  const {
    bookmarks,
    toggleBookmark,
    isVenueBookmarked,
    isSaving,
  } = useBookmarksContext()
  const isLiked = isVenueBookmarked(venue.id)
  const handleClick = async (event: any) => {
    event.preventDefault()
    await toggleBookmark(venue.id)
  }

  if (isSaving) {
    return <FontAwesomeIcon icon={faSpinner} spin />
  }

  return isLiked ? (
    <FontAwesomeIcon
      icon={faHeart}
      style={{ color: "red" }}
      onClick={handleClick}
    />
  ) : (
    <FontAwesomeIcon
      icon={farHeart}
      //   style={{ color: "white" }}
      onClick={handleClick}
    />
  )
}
